import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Control} from 'react-redux-form';

class CustomTextarea extends Component {
	render() {
		const {model, rows, className, updateOn, ...rest} = this.props;

		return (
			<Control.textarea
				rows={rows}
				className={className}
				model={`.${model}`}
				updateOn={updateOn}
				{...rest}
			/>
		)
	}
}

CustomTextarea.defaultProps = {
	rows: 4,
	className: 'form-control',
	updateOn: 'blur'
};

CustomTextarea.propTypes = {
	model: PropTypes.string.isRequired,
	rows: PropTypes.number,
	className: PropTypes.string,
	updateOn: PropTypes.string
};

export default CustomTextarea;